import React from "react";
import { cn } from "@/lib/utils";
import { priceText } from "@/lib/produkter";

/** Price as the eye reads it: number first, unit quiet. «Pr. time» and «Etter regning» are words, never 0. */
export function PriceText({ line, size = "md", className, testId }) {
  const p = priceText(line);
  return (
    <span className={cn("inline-flex items-baseline gap-1 whitespace-nowrap tabular-nums", className)} data-testid={testId} data-kind={p.kind} title={p.note || undefined}>
      <span className={cn(p.quiet ? "font-sans text-muted-foreground" : "font-mono font-medium text-foreground", size === "lg" ? "text-[28px] tracking-[-0.02em]" : size === "sm" ? "text-[12.5px]" : "text-[14px]")}>{p.main}</span>
      {p.unit ? <span className={cn("font-sans text-muted-foreground", size === "lg" ? "text-[14px]" : "text-[12px]")}>{p.unit}</span> : null}
    </span>
  );
}

export function StatusPill({ status, className }) {
  const label = { bekreftet: "Bekreftet", historisk: "Historisk", demo: "Demo", uavklart: "Uavklart" }[status] || status;
  const tone = status === "bekreftet" ? "bg-[hsl(var(--v-ok)/0.12)] text-[hsl(var(--v-ok))]" : status === "historisk" ? "bg-black/[0.06] text-foreground/70" : "bg-[hsl(var(--v-assumed-bg))] text-[hsl(var(--v-assumed))]";
  return <span className={cn("inline-flex h-[20px] items-center rounded-full px-2 text-[11.5px] font-medium", tone, className)} data-testid="produkt-status-pill">{label}</span>;
}

export function UsageChip({ usage, className }) {
  if (!usage?.cases) return null;
  return <span className={cn("inline-flex h-[20px] items-center rounded-full bg-black/[0.05] px-2 font-mono text-[11px] tabular-nums text-foreground/65", className)} data-testid="produkt-usage-chip">{usage.cases} {usage.cases === 1 ? "sak" : "saker"}</span>;
}
